<template>
  <div style="margin-top:20px">
    <el-form ref="form" label-width="80px" :model="form">
      <el-form-item label="编码" style="margin-right:15px">
        <el-input v-model="form.code" :disabled="true" />
      </el-form-item>
      <el-form-item label="状态" style="margin-right:15px">
        <el-input v-model="form.status" :disabled="true" />
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import request from "@/utils/request";

export default {
  name: "PalletDetail",
  data() {
    return {
      form: {
        code: "",
        status: "",
      },
    };
  },
  created() {},
  methods: {
    // 获取页面信息
    getInfo(code, statusData) {
      request({ url: "/ntocc-basic-api/pallet/" + code, method: "get" }).then(
        (response) => {
          this.form = response.data;
          const sd = statusData.find((i) => i.code === this.form.status);
          this.form.status = sd ? sd.name : "";
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin-top: 50px;
}
</style>
